module.exports = __webpack_public_path__ + "static/pokebowl-4a5072a9c62e6acce332096ed02ed0bf.png";